'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dropdown = require('../../blocks/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Action(_ref, context) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['children']);

  var hideContent = context[_constants.DROPDOWN_CONTEXT].hideContent;


  return _react2.default.createElement(
    _Dropdown2.default.Action,
    _extends({ onClick: hideContent }, rest),
    children
  );
}

Action.contextTypes = _defineProperty({}, _constants.DROPDOWN_CONTEXT, _propTypes2.default.object.isRequired);

Action.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = Action;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/Dropdown/Action.js
// module id = 1652
// module chunks = 2